import React from 'react';
import {
	MarkdownParagraph,
	QuickLinkExternal,
	StyledQuickLinks,
} from '../../../ui';

/**
 * Renders a paragraph with a link as single child element as a Quick Link
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const CustomQuickLinkParagraph = (props: any) => {
	const { children } = props;

	const quickLink = getQuickLinkParagraph(children);

	if (quickLink) {
		return (
			<StyledQuickLinks columns={1}>
				<QuickLinkExternal {...quickLink} />
			</StyledQuickLinks>
		);
	}

	return <MarkdownParagraph {...props} />;
};

interface IQuickLinkParagraphChild {
	url: string;
	title: string;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getQuickLinkParagraph(
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	children: any[] = [],
): IQuickLinkParagraphChild | undefined {
	try {
		if (
			children.length === 1 &&
			typeof children[0] === 'object' &&
			typeof children[0].props?.href === 'string' &&
			typeof children[0].props?.children[0] === 'string'
		) {
			return {
				url: children[0].props.href,
				title: children[0].props.children[0],
			};
		}
	} catch (e) {
		return undefined;
	}

	return undefined;
}
